import React from 'react';
import './Title.css';

function Title() {
  const scrollToForm = () => {
    const formElement = document.getElementById('join-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="title-container">
      <h1 className="tagline">
        A Girly Pop Approved Guide to Fertility Without the Spiral
      </h1>
      <p className="description">
        Real talk, real stories, and step-by-step answers for every fertility question you keep Googling at 2 AM.
      </p>
      <button className="waitlist-button" onClick={scrollToForm}>
        Join the Waitlist
      </button>
    </div>
  );
}

export default Title; 